import { createSelector } from 'reselect';

export const getApigeeDomainSelector = (state) => state.getIn(['config', 'apigeeDomain']);

export const postContextFeedbackApiUrlSelector = createSelector(
  getApigeeDomainSelector,
  (apigeeDomain) => `${apigeeDomain}/travel/v2/travel_services/context/feedback`
);
